import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { isIOS } from '../services/platform.service';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <PageHeader title="Plată Anulată" subtitle="Nu te îngrijora, poți încerca oricând" backTo="/dashboard" />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 text-center">
          {/* Cancel Icon */}
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center">
              <svg
                className="w-12 h-12 text-yellow-600 dark:text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>

          {/* Cancel Message */}
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Procesul a fost anulat
          </h2>
          
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Nu s-a perceput nicio taxă. Abonamentul tău nu a fost modificat.
          </p>

          {/* Reasons */}
          <div className="mb-8 bg-gray-50 dark:bg-gray-700 rounded-xl p-6 text-left">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
              De ce aleg utilizatorii să facă upgrade?
            </h3>
            <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
              <li className="flex items-start gap-2">
                <span className="text-green-500">✓</span>
                <span>Accesează AI nutritionist nelimitat pentru sfaturi personalizate</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500">✓</span>
                <span>Generează planuri de mese adaptate perfect nevoilor tale</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500">✓</span>
                <span>Analizează instant poze cu alimente pentru tracking precis</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500">✓</span>
                <span>Primești exerciții personalizate bazate pe obiectivele tale</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500">✓</span>
                <span>Economisești timp și obții rezultate mai rapide</span>
              </li>
            </ul>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <button
              onClick={() => navigate('/dashboard', { replace: true })}
              className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
            >
              Înapoi la Dashboard
            </button>
            <button
              onClick={() => navigate('/dashboard', { replace: true })}
              className="px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition"
            >
              Continuă
            </button>
          </div>

          <p className="text-sm text-gray-500 dark:text-gray-400">
            Ai întâmpinat probleme? <a href="/help" className="text-indigo-600 hover:underline">Contactează suportul</a>
          </p>
        </div>

        {/* FAQ */}
        <div className="mt-8 bg-white dark:bg-gray-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            ❓ Întrebări Frecvente
          </h3>
          <div className="space-y-4 text-sm">
            <div>
              <p className="font-semibold text-gray-900 dark:text-white mb-1">
                Pot să-mi schimb planul mai târziu?
              </p>
              <p className="text-gray-600 dark:text-gray-400">
                Da! Poți face upgrade sau downgrade oricând din pagina de Abonamente.
              </p>
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white mb-1">
                Pot cumpăra doar credite extra fără abonament?
              </p>
              <p className="text-gray-600 dark:text-gray-400">
                Da, poți cumpăra credite extra oricând, indiferent de planul tău actual.
              </p>
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white mb-1">
                Ce metode de plată acceptați?
              </p>
              <p className="text-gray-600 dark:text-gray-400">
                {isIOS() ? 'Plata se procesează securizat prin Apple.' : 'Acceptăm toate cardurile majore (Visa, Mastercard, Amex) prin Stripe, procesator de plăți securizat.'}
              </p>
            </div>
          </div>
        </div>

        {/* Special Offer */}
        <div className="mt-8 bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-xl p-6 border-2 border-indigo-200 dark:border-indigo-800">
          <div className="flex items-start gap-4">
            <div className="text-4xl">🎁</div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Ofertă Specială
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-3">
                Primii 100 de utilizatori care fac upgrade la planul Premium primesc +50 credite bonus gratuit!
              </p>
              <button
                onClick={() => navigate('/dashboard', { replace: true })}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-semibold hover:bg-indigo-700 transition"
              >
                Mergi la Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
